var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71985 6.78004C6.57934 6.92074 6.3887 6.99987 6.18985 7.00004H5.80985C5.61144 6.99774 5.42157 6.91893 5.27985 6.78004L0.149852 1.64004C0.055196 1.54616 0.00195312 1.41836 0.00195312 1.28504C0.00195312 1.15172 0.055196 1.02393 0.149852 0.930043L0.859852 0.220043C0.952016 0.125979 1.07816 0.0729713 1.20985 0.0729713C1.34154 0.0729713 1.46769 0.125979 1.55985 0.220043L5.99985 4.67004L10.4399 0.220043C10.5337 0.125386 10.6615 0.0721436 10.7949 0.0721436C10.9282 0.0721436 11.056 0.125386 11.1499 0.220043L11.8499 0.930043C11.9445 1.02393 11.9978 1.15172 11.9978 1.28504C11.9978 1.41836 11.9445 1.54616 11.8499 1.64004L6.71985 6.78004Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMoreIcon);
export default __webpack_public_path__ + "static/media/showMoreIcon.4c22893a.svg";
export { ForwardRef as ReactComponent };